import React from 'react';
import styled, { css } from 'styled-components';
import { useRouter } from 'next/router';

import { useTypedSelector } from '@/store/store';
import { selectSinglePost } from '@/store/reducers/single-post';
import { media } from '@/utils/mixin';
import { BlogCategory } from '@/typings/model';

import ArticleCard from '../ArticleCard';
import { getIconByType, getParentPageTitle } from '../utils';

function Others() {
  const page = useTypedSelector(selectSinglePost);
  const parentRoute = useRouter().asPath.split('/')[1] as BlogCategory;

  if (!page) {
    return null;
  }

  return (
    <Component>
      <ComponentContainer>
        <TitleContainer>
          <Title>С этим читали</Title>
        </TitleContainer>

        <ArticleList>
          {page.relatedPosts.map(({ image, title, url }, index) => (
            <ArticleCard
              key={index}
              title={title ?? ''}
              url={url ?? ''}
              image={image}
              category={{
                label: getParentPageTitle(parentRoute),
                icon: getIconByType(parentRoute),
              }}
            />
          ))}
        </ArticleList>
      </ComponentContainer>
    </Component>
  );
}

export default Others;

const Component = styled.div`
  background: ${(props) => props.theme.gray};
`;

const ComponentContainer = styled.div`
  padding: 85px 20px 50px 20px;

  @media (min-width: 1400px) {
    padding: 90px 30px 106px 30px;
  }
`;

const TitleContainer = styled.div`
  width: 100%;
  max-width: 920px;
  margin: 0 auto 20px auto;

  @media (min-width: 1400px) {
    margin: 0 auto 40px auto;
  }
`;

const Title = styled.span`
  display: block;

  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
  text-align: center;
  color: ${(props) => props.theme.black100};

  @media (min-width: 1400px) {
    margin: 0 auto;

    font-size: 30px;
    line-height: 75px;
  }
`;

const ArticleList = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;

  ${media.mobileUp(
    css`
      grid-template-columns: repeat(2, 1fr);
    `
  )};

  @media (min-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
